import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  loadAgingBalance,
  loadAgingBalanceResumeList
} from 'src/store/actions/accountingActions';
import {
  selectAgingBalanceQueryOptions,
  selectAgingBalanceResumeQueryOptions
} from 'src/store/selectors/accountingSelector';
import AgingBalanceList from './AgingBalanceList';
import AgingBalanceResumeList from './AgingBalanceResumeList';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function selectBalanceType(value) {
  switch (Number(value)) {
    case 0:
      return 'CLIENT';
    case 1:
      return 'CONTRACT';
    default:
      return 'CLIENT';
  }
}

const AgingBalanceTabs = ({ tabIndex = 0, setTabIndex }) => {
  const queryOpts = useSelector(selectAgingBalanceQueryOptions);
  const resumeQueryOpts = useSelector(selectAgingBalanceResumeQueryOptions);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (tabIndex === 2) {
      dispatch(
        loadAgingBalanceResumeList({
          ...resumeQueryOpts,
          page: 0
        })
      );
    } else {
      dispatch(
        loadAgingBalance({
          ...queryOpts,
          balanceType: selectBalanceType(tabIndex),
          page: 0
        })
      );
    }
  }, []);

  const handleChange = useCallback(
    (_, newValue) => {
      if (setTabIndex) {
        setTabIndex(newValue);
      }
      if (newValue === 2) {
        dispatch(
          loadAgingBalanceResumeList({
            ...resumeQueryOpts,
            page: 0
          })
        );
      } else {
        dispatch(
          loadAgingBalance({
            ...queryOpts,
            balanceType: selectBalanceType(newValue),
            page: 0
          })
        );
      }
    },
    [setTabIndex, dispatch, queryOpts, resumeQueryOpts]
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={tabIndex}
          onChange={handleChange}
        >
          <Tab label={t('AGING_BALANCE.CLIENTS')} />
          <Tab label={t('AGING_BALANCE.CONTRACTS')} />
          <Tab label={t('AGING_BALANCE.RESUME')} />
        </Tabs>
      </AppBar>
      <TabPanel value={tabIndex} index={0}>
        <AgingBalanceList showFolio={false} />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <AgingBalanceList showFolio />
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <AgingBalanceResumeList />
      </TabPanel>
    </Box>
  );
};

AgingBalanceTabs.propTypes = {
  tabIndex: PropTypes.number,
  setTabIndex: PropTypes.func
};

export default AgingBalanceTabs;
